//@ts-check

import { get, getAll, getById } from "../utilities/querySelector";

let activeElement;

export const modalContainer = /** @type {HTMLElement} */ ( getById( 'site-modal' ) );

export const closeButton = /** @type {HTMLButtonElement} */ ( get( '[data-modal-close]', modalContainer ) );

closeButton.addEventListener( 'click', fadeout );
modalContainer.addEventListener( 'click', ( e ) => {
  if ( e.target === modalContainer ) fadeout();
} );

const openers = getAll( '[data-modal-open]' );
openers.forEach( opener => opener.addEventListener( 'click', () => {
  if ( modalContainer.dataset.active === 'true' ) deactivate();
  activeElement = opener;
  const modal = opener.dataset.modalOpen;
  activate( modal );
} )
);

function preventBodyScroll() {
  document.body.style.overflowY = 'hidden';
}

function enableBodyScroll() {
  document.body.style.overflowY = 'auto';
}


/**
 * "Activates" the specified modal, opening the modal in the process
 * @param {string} modalName
 */
export function activate( modalName ) {
  get( `[data-modal=${modalName}]`, modalContainer ).dataset.active = 'true';
  modalContainer.dataset.active = 'true';
  fadein();
  closeButton.focus();
  preventBodyScroll();
  document.addEventListener( 'keydown', escHandler );
}

/**
 * Sets the active state of all modals to false
 */
function deactivate() {
  modalContainer.dataset.active = false;
  getAll( `[data-active=true]`, modalContainer ).forEach( activeModal => activeModal.dataset.active = 'false' );

  // Remove status of contact form
  get( '.wpcf7-form', modalContainer )?.reset();

  enableBodyScroll();
  document.removeEventListener( 'keydown', escHandler );
}

/**
 * Opens the main modal up
 */
function fadein() {
  modalContainer.animate( {
    opacity: [0, 1]
  }, 350 );
}

function fadeout() {
  activeElement?.focus();
  const animation = modalContainer.animate( {
    opacity: [1, 0]
  }, 350 );
  animation.addEventListener( 'finish', () => {
    deactivate();
  } );
}

function escHandler( e ) {
  if ( e.key !== 'Escape' ) return;
  fadeout();
}